/**
 * Auto-Sign-In Service
 *
 * ⚠️⚠️⚠️ REMOVE BEFORE LAUNCH ⚠️⚠️⚠️
 *
 * IMPORTANT: This is a TEMPORARY service for demo purposes only.
 * This ENTIRE FILE should be DELETED before production launch.
 *
 * Purpose:
 * - Automatically sign in users with preset credentials for demo
 * - Hardcoded credentials for reliability during demo
 *
 * Security Warning:
 * - Demo credentials are HARDCODED in this file
 * - This feature bypasses normal authentication flow
 * - MUST be removed before any public release
 *
 * TO REMOVE BEFORE LAUNCH:
 * 1. Delete this file: apps/mobile/src/services/autoSignInService.ts
 * 2. Remove imports from LoginScreen.tsx
 * 3. Remove auto-sign-in useEffect from LoginScreen.tsx
 * 4. Remove demo banner from LoginScreen.tsx
 */

// ========================================================================
// 🚨🚨🚨 TEMPORARY DEMO CREDENTIALS - DELETE BEFORE LAUNCH 🚨🚨🚨
// ========================================================================
const DEMO_CREDENTIALS = {
  enabled: true, // Set to false to disable auto-sign-in
  email: 'meshal516@yahoo.com',
  password: 'TestPass123!',
};
// ========================================================================

export interface AutoSignInConfig {
  enabled: boolean;
  credentials: {
    email: string;
    password: string;
  } | null;
}

/**
 * Checks if auto-sign-in feature is enabled and credentials are available
 *
 * 🚨 REMOVE BEFORE LAUNCH
 *
 * @returns Configuration object with enabled status and credentials
 */
export function getAutoSignInConfig(): AutoSignInConfig {
  if (!DEMO_CREDENTIALS.enabled) {
    return {
      enabled: false,
      credentials: null,
    };
  }

  return {
    enabled: true,
    credentials: {
      email: DEMO_CREDENTIALS.email,
      password: DEMO_CREDENTIALS.password,
    },
  };
}

/**
 * Checks if auto-sign-in should be triggered
 *
 * 🚨 REMOVE BEFORE LAUNCH
 *
 * @returns true if auto-sign-in is enabled and properly configured
 */
export function shouldAutoSignIn(): boolean {
  const config = getAutoSignInConfig();
  return config.enabled && config.credentials !== null;
}

/**
 * Gets demo credentials for auto-sign-in
 *
 * 🚨 REMOVE BEFORE LAUNCH
 *
 * @returns Demo credentials or null if not available
 */
export function getAutoSignInCredentials() {
  const config = getAutoSignInConfig();
  return config.credentials;
}

/**
 * Logs auto-sign-in activity
 * Useful for debugging and ensuring transparency during demo
 *
 * 🚨 REMOVE BEFORE LAUNCH
 */
export function logAutoSignInActivity(message: string, data?: any): void {
  console.log(`[AutoSignIn - DEMO MODE] ${message}`, data || '');
}
